import { MenuButton } from '../menu-button'
import { MenuButtonProps } from '../menu-button/MenuButton'
import { DropdownMenuItem as StyledDropdownMenuItem } from './styles'

export const DropdownMenuItem = ({ color, ...props }: MenuButtonProps) => {
  return (
    <StyledDropdownMenuItem asChild $color={color}>
      <MenuButton {...props} />
    </StyledDropdownMenuItem>
  )
}

DropdownMenuItem.displayName = 'DropdownMenuItem'
